import { Component, createRef } from 'react';
import CenteredRowDiv from '../shared/CenteredRowDiv';

export class GoogleAdSlot extends Component {
  constructor(props) {
    super(props);

    this.onGoogletagInitialized = this.onGoogletagInitialized.bind(this);
    this.slotRef = createRef();
  }

  componentDidMount() {
    if (window.wasGoogletagInitialized) {
      this.onGoogletagInitialized();
    } else {
      window.document.addEventListener('googletagInitialized', this.onGoogletagInitialized);
    }
  }

  componentWillUnmount() {
    window.document.removeEventListener('googletagInitialized', this.onGoogletagInitialized);
  }

  onGoogletagInitialized() {
    const { adId, verticalMargin = 0 } = this.props;

    if (window && window.googletag) {
      const { googletag } = window;

      googletag.cmd.push(() => {
        const slot = googletag.pubads().getSlots().find((s) => s.getSlotElementId() === adId);

        googletag.display(adId);

        if (slot) {
          googletag.pubads().refresh([slot]);
        }
      });

      // Add margins only when ad is actually displayed
      if (this.slotRef.current) {
        this.slotRef.current.style.marginTop = `${verticalMargin}px`;
        this.slotRef.current.style.marginBottom = `${verticalMargin}px`;
      }
    }
  }

  render() {
    const { adId } = this.props;

    return (
      <div ref={this.slotRef}>
        <CenteredRowDiv id={adId} />
      </div>
    );
  }
}
